export default "__VITE_ASSET__CMiPPlsd__"